import { useMutation } from "react-query";
import http from "shared/http";

export interface PageResource {
  id: number;
  title: string;
  url: string;
  iconName?: string;
  mode?: "NONE" | "WINDOW" | "TAB";
  isHidden?: boolean;
  resourceTier?: string;
  summary?: string;
  categories: string[];
  roles?: string[];
  isActive?: boolean;
}

export const useUpsertPageMutation = () => {
  return useMutation(async (page: PageResource) => {
    if (page.id > 0) {
      return await http.putAsync(`admin/pages/${page.id}`, page);
    }
    return await http.postAsync("admin/pages", page);
  });
};
